var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      staticClass: "basic-select",
      attrs: { autocomplete: "off", disabled: _vm.disable },
      domProps: { value: _vm.value },
      on: { change: _vm.emitInput },
    },
    [
      _vm.renderBlankOptions
        ? _c(
            "option",
            {
              attrs: {
                value: "",
                "aria-selected": _vm.renderBlankOptions.selected,
              },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.renderBlankOptions.external) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.renderedOptions, function (option) {
        return _c(
          "option",
          {
            key: option.external,
            attrs: { "aria-selected": option.selected },
            domProps: { value: option.internal },
          },
          [_vm._v("\n      " + _vm._s(option.external) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }